// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"25":"pages/SpanishPage","76":"common"}[chunkId] + ".css";
};